import request from '@/utils/service'

export function list(data) {
  return request({
    url: '/monthCard/list',
    method: 'get',
    params: data
  })
}

export function add(data) {
  return request({
    url: '/monthCard/add',
    method: 'post',
    data
  })
}
export function detail(data) {
  return request({
    url: '/monthCard/detail',
    method: 'get',
    params: data
  })
}
export function edit(data) {
  console.log('data :>> ', data)
  return request({
    url: '/monthCard/update',
    method: 'post',
    data
  })
}

export function history(params) {
  return request({
    url: '/monthCardOrder/list',
    method: 'get',
    params
  })
}
export function deleteApi(data) {
  return request({
    url: '/monthCard/delete',
    method: 'post',
    data
  })
}

export function updateStatus(data) {
  return request({
    url: '/monthCard/update/status',
    method: 'post',
    data
  })
}
export function refund(data) {
  return request({
    url: '/monthCardOrder/refund',
    method: 'post',
    data
  })
}
